const getters = {
  getLeaveRequests: state => state.leaveRequests,
  getLeaveRequest: state => state.leaveRequest

}


export default getters